import React from 'react';
import { Registration } from '../../store/models/Registration';
import { Instance } from 'mobx-state-tree';
import styled from '@emotion/styled';
import DOMPurify from 'dompurify';
import ReactHtmlParser from 'react-html-parser';
import { TLCode } from '../../common/enums';
import { TranslatedMessage } from '../common/translation';

interface UserRegistrationDetailsProps {
  registration: Instance<typeof Registration>;
}

interface UserRegistrationInfoProps {
  label: TLCode;
  value?: string;
  interpretHTML?: boolean;
}

const Container = styled.div`
  display: flex;
  width: 70%;
  flex-direction: column;
`;

const UserRegistrationInfo = ({ label, value, interpretHTML }: UserRegistrationInfoProps) => {
  return (
    <div style={{ display: 'flex', width: '100%', flexDirection: 'row' }}>
      <span style={{ width: '175px', fontWeight: 'bold' }}>
        <TranslatedMessage id={label} />
      </span>
      <span>{interpretHTML ? ReactHtmlParser(DOMPurify.sanitize(value)) : value}</span>
    </div>
  );
};

export const UserRegistrationDetails = ({ registration }: UserRegistrationDetailsProps) => {
  return (
    <Container>
      <UserRegistrationInfo value={registration.firstname} label={TLCode.Firstname} />
      <UserRegistrationInfo value={registration.lastname} label={TLCode.Lastname} />
      <UserRegistrationInfo value={registration.email} label={TLCode.Email} />
      <UserRegistrationInfo value={registration.userName} label={TLCode.Username} />
      <UserRegistrationInfo value={registration.role} label={TLCode.USER_Registration_Role} />
      <UserRegistrationInfo value={registration.organization} label={TLCode.USER_Registration_Organization} />
      <UserRegistrationInfo value={registration.category} label={TLCode.USER_Registration_Category} />
      <UserRegistrationInfo value={registration.address} label={TLCode.USER_Registration_Address} />
      <UserRegistrationInfo value={registration.phoneNumber} label={TLCode.USER_Registration_PhoneNumber} />
      <UserRegistrationInfo
        value={registration.requestRegistrationMessage}
        label={TLCode.USER_Registration_Request}
        interpretHTML
      />
    </Container>
  );
};
